import { render, staticRenderFns } from "./ComponentDashboard.vue?vue&type=template&id=72746d91&"
import script from "./ComponentDashboard.vue?vue&type=script&lang=js&"
export * from "./ComponentDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports